export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.sys-manager': '系统管理',
  'menu.sys-manager.user-list': '用户管理',
  'menu.sys-manager.role': '角色管理',
  'menu.sys-manager.department': '部门管理',
  'menu.sys-manager.menu': '菜单管理',
  'menu.sys-manager.data-permission': '数据权限',
  'menu.sign-template': '模板管理',
  'menu.sign-template.template-sign': '签署模板',
  'menu.sign-template.template-video': '视频告知',
  'menu.sign-template.template-file': '文件模板',
  'menu.sign-template.template-file-edit': '文档编辑',
  'menu.sign-template.sign-file-edit': '签署文件编辑',
  'menu.sign-template.pdf-stamp-edit': '印章编辑',
  'menu.sign-template.tag': '变量管理',
  'menu.sign-process': '流程管理',
  'menu.sign-center': '签署人中心',
  'menu.sign-center.person': '签署个人',
  'menu.sign-center.enterprise': '签署企业',
  'menu.sign-manage': '签署管理',
  'menu.sign-manage.published-sign': '发布签署',
  'menu.sign-manage.draft-box': '草稿箱',
  'menu.sign-manage.published': '已发布',
  'menu.sign-manage.published-detail': '签署详情',
  'menu.sign-manage.archived': '已归档',
  'menu.sign-manage.archived-detail': '归档详情',
  'menu.sign-auth': '授权中心',
  'menu.sign-auth.publish-auth': '发布授权',
  'menu.sign-auth.draft-box': '草稿箱',
  'menu.sign-auth.published': '已发布',
  'menu.sign-auth.published-detail': '签署详情',
  'menu.sign-auth.archived': '已归档',
  'menu.sign-auth.archived-detail': '归档详情',
  'menu.sign-auth.auth-manage': '授权管理',
  'menu.seal-manage': '签章管理',
  'menu.seal-manage.seal-company': '企业签章',
  'menu.feedback': '反馈中心',
  'menu.feedback.record': '反馈管理',
  'menu.feedback.record-detail': '反馈详情',
  'menu.feedback.template': '反馈模板',
  'menu.feedback.number-segment': '号段管理',
  'menu.feedback.prefix': '前缀管理',
  'menu.data-stat': '用量统计',
  'menu.data-stat.cfca24-verify': '二四要素',
  'menu.data-stat.sign-stat': '签署统计',
};
